import styled from 'styled-components';
import { spacing } from 'commons';

export const Main = styled.div`
  position: relative;
  display: flex;
  overflow: hidden;
  height: 100%;
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding: 0 calc(15px - ${spacing.scrollbarSize}) 0 30px;
  margin: 0 15px 15px 0;
  gap: 15px;
  overflow-y: scroll;
`;

export const ValidationWrapper = styled.div`
  position: absolute;
  top: 24px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  justify-content: center;
  width: 80%;
  background: ${({ theme }) => theme.neutral_100};
  padding: 8px 20px;
  border: 1px solid ${({ theme }) => theme.neutral_200};
  border-radius: 8px;
`;

export const TextWrapper = styled.div<{ $start?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: ${({ $start }) => ($start ? 'flex-start' : 'center')};
  padding-top: 20px;
`;
